import React, { useEffect, useState } from 'react';
import { message, DatePicker, Form, Input, Select, Skeleton } from "antd";
import { Button } from "evergreen-ui";
import Firebase from "../../Firebase/Firebase";
import { useListVals } from "../../Firebase/databaseHooks";
import { getDatabase, ref } from "firebase/database";
import FireFetch from "../../Firebase/FireFetch";
import { useAuth } from "../../AuthContext/AuthContext";
import { isActiveUserStatus } from "../../../constants/userStatus";
import { filterSelectOption, sortSelectOptions } from "../../utils/selectOptions.js";
import {
	getPriorityEndpoint,
	serializePriorityForSource,
} from "../../Pages/FeedbackPages/priorityCompat";


var db = getDatabase(Firebase);
const moment = require("moment");
const EditPriority = (props) => {
    const { canAccessModule } = useAuth();
    const canUpdatePriority = canAccessModule("COMMUNITY_PRIORITIES", "update");

    const [showLoading, setShowLoading] = useState(false);
    const [organizationArray, organizationsLoading] = useListVals(ref(db, "talmidsdb/organisations"));
    const [communityArray, communitiesLoading] = useListVals(ref(db, "talmidsdb/communities"));
    const [userArray, usersLoading] = useListVals(ref(db, "talmidsdb/users"));
    const [initiativeArray, initiativesLoading] = useListVals(ref(db, "talmidsdb/initiatives"));
    const isLookupLoading =
        organizationsLoading ||
        communitiesLoading ||
        usersLoading ||
        initiativesLoading;


    useEffect(() => {
        if (userArray) {
        }
    }, [userArray]);


    const handleCreate = (values) => {
        if (!canUpdatePriority) {
            message.error("You do not have permission to update priorities.");
            return;
        }

        setShowLoading(true);
        const canonicalValues = {
            ...values,
            startDate: values.startDate.format("YYYY-MM-DDThh:mm"),
            endDate: values.endDate.format("YYYY-MM-DDThh:mm"),
        };
        const priorityObject = serializePriorityForSource(canonicalValues, props.priority);

        const output = FireFetch.UpdateInDB(
            getPriorityEndpoint(props.priority),
            props.priority?.priorityID || props.priority?.id,
            priorityObject
        );
        output.then((result) => {
            console.log(result);
            if (result === "success") {
                FireFetch.addLog("priorities", props.priority?.priorityID || props.priority?.id, "Edit");
                message.success("Priority edited successfully");
                props.modal(false);
                setShowLoading(false);
            } else {
                message.error("Unable to edit Priority an error occurred :: " + result);
                setShowLoading(false);
            }
        });

    }


    if (isLookupLoading) {
        return <Skeleton active paragraph={{ rows: 9 }} />;
    }

    return (
        <>
            <Form layout={"vertical"}
                onFinish={handleCreate}
                initialValues={{
                    communityID: props.priority?.communityID,
                    endDate: moment(props.priority?.endDate, "YYYY-MM-DDThh:mm"),
                    initiativeID: props.priority?.initiativeID,
                    organisationID: props.priority?.organisationID,
                    priority: props.priority?.priority,
                    responsibleUserID: props.priority?.responsibleUserID,
                    startDate: moment(props.priority?.startDate, "YYYY-MM-DDThh:mm"),

                }}

            >

                <Form.Item label="Priority"
                    name="priority"
                    rules={[{ required: true, message: 'Enter priority!' }]}
                >
                    <Input placeholder="Enter Priority" id="priority" />
                </Form.Item>

                <Form.Item label="Organization"
                    name="organisationID"
                    rules={[{ required: true, message: 'Choose Organization!' }]}>
                    <Select placeholder="Select organisation"
                        showSearch
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {organizationArray.map((item, index) => (
                            <Select.Option key={index} value={item.orgID}>{item.name}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>
                <Form.Item label="Community"
                    name="communityID"
                    rules={[{ required: true, message: 'Choose Community!' }]}>
                    <Select placeholder="Select community"
                        showSearch
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {communityArray.map((item, index) => (
                            <Select.Option key={index} value={item.communityID}>{item.name}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>
                <Form.Item label="Initiative"
                    name="initiativeID"
                    rules={[{ required: true, message: 'Choose initiative!' }]}>
                    <Select placeholder="Select initiative"
                        showSearch
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {initiativeArray.map((item, index) => (
                            <Select.Option key={index} value={item.initiativeID}>{item.initiative}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>

                <Form.Item
                    label="Start Date"
                    name="startDate"
                    rules={[{ required: true, message: "Choose start date" }]}>
                    <DatePicker
                        placeholder="select starting date"
                        picker={"date"}
                        showTime={{ format: 'HH:mm' }}
                        className="w-100" />

                </Form.Item>
                <Form.Item
                    label="End Date"
                    name="endDate"
                    rules={[{ required: true, message: "Choose end date" }]}>
                    <DatePicker
                        placeholder="select ending date"
                        picker={"date"}
                        showTime={{ format: 'HH:mm' }}
                        className="w-100" />

                </Form.Item>

                <Form.Item label="Responsible User"
                    name="responsibleUserID"
                    rules={[{ required: true, message: 'Choose responsible user!' }]}>
                    <Select placeholder="Select user"
                        showSearch
                        optionFilterProp="children"
                        filterOption={filterSelectOption}
                        filterSort={sortSelectOptions}>
                        {userArray.filter((x) => isActiveUserStatus(x.userStatus)).map((item, index) => (
                            <Select.Option key={index} value={item.id}>{item.firstname + " " + item.surname}</Select.Option>
                        ))}

                    </Select>
                </Form.Item>


                <Button appearance="primary" htmlType="submit" loading={showLoading} disabled={!canUpdatePriority}>
                    Edit
                </Button>
            </Form>
        </>
    )
}

export default EditPriority;
